import React, { useState } from 'react';
import { API_BASE_URL, GraphicGroupSelector, GraphicTypeContainers, ChartSelector, renderModal, closeModal, saveWidgetThemeToDatabase, fetchData} from './Common';
import './ChartWidgetCreator.css';
import { ReactComponent as MugIcon } from '../icons/mug.svg';
import axios from 'axios';

function ChartWidgetCreator({
  tableColumnData,
  isTablesLoaded,
  tables,
  projectId,
  setDashboards,
  setIsDashboardsLoaded,
  setWidgets,
  setIsWidgetsLoaded
}) {

  const [selectedDatasets, setselectedDatasets] = useState([]);
  const [graphType, setGraphType] = useState('');
  const [newWidgetName, setnewWidgetName] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalMessageColor, setModalMessageColor] = useState('');
  const [modalIconId, setModalIconId] = useState(1);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [isCreating, setIsCreating] = useState(false);

const dashboardTypeContainersData = [
  {
    title: "Em Branco",
    topics: [
      "Crie o seu dashboard do zero, pronto para construir à medida das necessidades"
    ],
    chartGroup: 9,
  },

  {
    title: "Analítico",
    topics: [
      "Aprofunde dados para revelar padrões e apoiar decisões estratégicas"
    ],
    chartGroup: 10,
  },

  {
    title: "Operações",
    topics: [
      "Mostre informação em tempo real para acompanhar tarefas e agir rapidamente"
    ],
    chartGroup: 11,
  },

  {
    title: "Apresentação",
    topics: [
      "Resuma apenas o essencial, ideal para comunicar insights de forma clara e visual"
    ],
    chartGroup: 12,
  },
];

const handleCreateWidget = async () => {
  try {
    setIsCreating(true);
    const token = localStorage.getItem('token');

    // 1️⃣ Create dashboard
    const dashboardResponse = await axios.post(
      `${API_BASE_URL}/dashboards`,
      {
        name: newWidgetName,
        databaseId: projectId,
        theme: 1,
        widgets: []
      },
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );

    const dashboardId = Object.keys(dashboardResponse.data.duplicatedDashboard)[0];
    const newDashboard = dashboardResponse.data.duplicatedDashboard[dashboardId];

    // Helper to create widgets
    const createWidget = async (graphType, conteudo = "") => {
      const res = await axios.post(
        `${API_BASE_URL}/widgets`,
        {
          projectId,
          graphType,
          conteudo,
          label: "0",
          name: "",
          dataset: null
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return Object.keys(res.data.duplicatedWidget)[0];
    };

    let layout = [];

const widgetThemesToApply = {}; // widgetId -> theme
const temaThemes = [5, 6, 3, 4];

    // 2️⃣ Dashboards types
    switch (selectedGroup) {
      case 10: // Analítico
        {
          const titleId = await createWidget("100", "Insira um título");
          const paragraphId = await createWidget("101", "Insira aqui uma descrição breve do seu dashboard");
          const subtitleFullId = await createWidget("103", "Insira um subtítulo");

          const paragraphIds = await Promise.all(
            Array.from({ length: 4 }, (_, i) =>
              createWidget("101", `Tema ${i + 1}`)
            )
          );

          const titleUnderThemesIds = await Promise.all(
            Array.from({ length: 4 }, (_, i) =>
              createWidget("100", `Dados ${i + 1}`)
            )
          );

          const subtitleLeftId = await createWidget("103", "Insira um subtítulo");
          const subtitleRightId = await createWidget("103", "Insira um subtítulo");

          const placeholderLeftId = await createWidget("104", "line");
          const placeholderRightId = await createWidget("104", "pie");

          const paragraphBottomId = await createWidget("101", "Insira uma informação complementar ou explicativa sobre os widgets");
          const placeholderBottomId = await createWidget("104", "table");

          layout = [
            { x: 0, y: 0, w: 12, h: 1, i: titleId, resizeHandles: ["sw","nw","se"], static: false },
            { x: 0, y: 1, w: 12, h: 2, i: paragraphId, resizeHandles: ["sw","nw","se"], static: false },
            { x: 0, y: 4, w: 12, h: 1, i: subtitleFullId, resizeHandles: ["sw","nw","se"], static: false },

            { x: 0, y: 5, w: 3, h: 2, i: paragraphIds[0], resizeHandles: ["sw","nw","se"], static: false },
            { x: 3, y: 5, w: 3, h: 2, i: paragraphIds[1], resizeHandles: ["sw","nw","se"], static: false },
            { x: 6, y: 5, w: 3, h: 2, i: paragraphIds[2], resizeHandles: ["sw","nw","se"], static: false },
            { x: 9, y: 5, w: 3, h: 2, i: paragraphIds[3], resizeHandles: ["sw","nw","se"], static: false },

            { x: 0, y: 7, w: 3, h: 1, i: titleUnderThemesIds[0], resizeHandles: ["sw","nw","se"], static: false },
            { x: 3, y: 7, w: 3, h: 1, i: titleUnderThemesIds[1], resizeHandles: ["sw","nw","se"], static: false },
            { x: 6, y: 7, w: 3, h: 1, i: titleUnderThemesIds[2], resizeHandles: ["sw","nw","se"], static: false },
            { x: 9, y: 7, w: 3, h: 1, i: titleUnderThemesIds[3], resizeHandles: ["sw","nw","se"], static: false },

            { x: 0, y: 9, w: 6, h: 1, i: subtitleLeftId, resizeHandles: ["sw","nw","se"], static: false },
            { x: 6, y: 9, w: 6, h: 1, i: subtitleRightId, resizeHandles: ["sw","nw","se"], static: false },

            { x: 0, y: 10, w: 6, h: 4, i: placeholderLeftId, resizeHandles: ["sw","nw","se"], static: false },
            { x: 6, y: 10, w: 6, h: 4, i: placeholderRightId, resizeHandles: ["sw","nw","se"], static: false },

            { x: 0, y: 14, w: 12, h: 2, i: paragraphBottomId, resizeHandles: ["sw","nw","se"], static: false },
            { x: 0, y: 16, w: 12, h: 3, i: placeholderBottomId, resizeHandles: ["sw","nw","se"], static: false }
          ];
        }
        break;

      case 11: // Operações
{
  // --- TOP (same as Analítico) ---
  const titleId = await createWidget("100", "Insira um título");
  const paragraphId = await createWidget("101", "Insira aqui uma descrição breve do seu dashboard");
  const subtitleFullId = await createWidget("103", "Insira um subtítulo");

  const paragraphIds = await Promise.all(
  Array.from({ length: 4 }, (_, i) =>
    createWidget("101", `Tema ${i + 1}`)
  )
);
  /*const paragraphIds = await Promise.all(
  Array.from({ length: 4 }, async (_, i) => {
    const id = await createWidget("101", `Tema ${i + 1}`);
    widgetThemesToApply[id] = temaThemes[i];
    return id;
  })
);*/

  const titleUnderThemesIds = await Promise.all(
    Array.from({ length: 4 }, (_, i) =>
      createWidget("100", `Dados ${i + 1}`)
    )
  );

  // --- NEW OPERATIONS CONTENT ---
  const rowOneParagraphs = await Promise.all(
    Array.from({ length: 3 }, (_, i) =>
      createWidget("101", `Estado ${i + 1}`)
    )
  );

  const rowTwoParagraphs = await Promise.all(
    Array.from({ length: 3 }, (_, i) =>
      createWidget("101", `Informação ${i + 1}`)
    )
  );

  rowOneParagraphs.forEach((id, i) => {
  const color = temaThemes[i]; // column i color
  widgetThemesToApply[id] = color;           // rowOne
  widgetThemesToApply[rowTwoParagraphs[i]] = color; // same color for rowTwo
});

  const subtitleTopId = await createWidget("103", "Insira um subtítulo");
  const placeholderId = await createWidget("104", "line");
  const subtitleBottomId = await createWidget("103", "Insira um subtítulo");
  const finalParagraphId = await createWidget("101", "Insira um texto explicativo");

  layout = [
    // --- TOP ---
    { x: 0, y: 0, w: 12, h: 1, i: titleId, resizeHandles: ["sw","nw","se"], static: false },
    { x: 0, y: 1, w: 12, h: 2, i: paragraphId, resizeHandles: ["sw","nw","se"], static: false },
    { x: 0, y: 4, w: 12, h: 1, i: subtitleFullId, resizeHandles: ["sw","nw","se"], static: false },

    { x: 0, y: 5, w: 3, h: 2, i: paragraphIds[0], resizeHandles: ["sw","nw","se"], static: false },
    { x: 3, y: 5, w: 3, h: 2, i: paragraphIds[1], resizeHandles: ["sw","nw","se"], static: false },
    { x: 6, y: 5, w: 3, h: 2, i: paragraphIds[2], resizeHandles: ["sw","nw","se"], static: false },
    { x: 9, y: 5, w: 3, h: 2, i: paragraphIds[3], resizeHandles: ["sw","nw","se"], static: false },

    { x: 0, y: 7, w: 3, h: 1, i: titleUnderThemesIds[0], resizeHandles: ["sw","nw","se"], static: false },
    { x: 3, y: 7, w: 3, h: 1, i: titleUnderThemesIds[1], resizeHandles: ["sw","nw","se"], static: false },
    { x: 6, y: 7, w: 3, h: 1, i: titleUnderThemesIds[2], resizeHandles: ["sw","nw","se"], static: false },
    { x: 9, y: 7, w: 3, h: 1, i: titleUnderThemesIds[3], resizeHandles: ["sw","nw","se"], static: false },

    // --- ROW 1: 3 paragraphs ---
    { x: 0, y: 9, w: 4, h: 1, i: rowOneParagraphs[0], resizeHandles: ["sw","nw","se"], static: false },
    { x: 4, y: 9, w: 4, h: 1, i: rowOneParagraphs[1], resizeHandles: ["sw","nw","se"], static: false },
    { x: 8, y: 9, w: 4, h: 1, i: rowOneParagraphs[2], resizeHandles: ["sw","nw","se"], static: false },

    // --- ROW 2: 3 paragraphs ---
    { x: 0, y: 10, w: 4, h: 2, i: rowTwoParagraphs[0], resizeHandles: ["sw","nw","se"], static: false },
    { x: 4, y: 10, w: 4, h: 2, i: rowTwoParagraphs[1], resizeHandles: ["sw","nw","se"], static: false },
    { x: 8, y: 10, w: 4, h: 2, i: rowTwoParagraphs[2], resizeHandles: ["sw","nw","se"], static: false },

    // --- Subtitle ---
    { x: 0, y: 13, w: 12, h: 1, i: subtitleTopId, resizeHandles: ["sw","nw","se"], static: false },

    // --- Placeholder ---
    { x: 0, y: 14, w: 12, h: 4, i: placeholderId, resizeHandles: ["sw","nw","se"], static: false },

    // --- Subtitle ---
    { x: 0, y: 19, w: 12, h: 1, i: subtitleBottomId, resizeHandles: ["sw","nw","se"], static: false },

    // --- Final paragraph ---
    { x: 0, y: 20, w: 12, h: 2, i: finalParagraphId, resizeHandles: ["sw","nw","se"], static: false }
  ];
}
break;


      case 12: // Apresentação
{
  // --- ROW 1 ---
  const titleId = await createWidget("100", "Título da apresentação");
  const logoId = await createWidget("102", "images/prochild.png");
  const paragraphId = await createWidget("101", "Introdução / contexto da apresentação");

  // --- THEMES & DATA (same pattern as previous) ---
  const subtitleThemesId = await createWidget("103", "Insira um subtítulo");

  const themeParagraphIds = await Promise.all(
    Array.from({ length: 4 }, (_, i) =>
      createWidget("101", `Tema ${i + 1}`)
    )
  );

  const dataTitleIds = await Promise.all(
    Array.from({ length: 4 }, (_, i) =>
      createWidget("100", `Dados ${i + 1}`)
    )
  );

  // --- APPLY COLORS TO BOTH ---
themeParagraphIds.forEach((id, i) => {
  const color = temaThemes[i];         // assign color
  widgetThemesToApply[id] = color;     // Tema i+1
  widgetThemesToApply[dataTitleIds[i]] = color; // Dados i+1
});

  // --- WIDGETS & CONTENT ---
  const fullWidgetTopId = await createWidget("104", "line");

  const leftWidgetId = await createWidget("104", "bar");
  const rightSubtitleId = await createWidget("103", "Insira um subtítulo");
  const rightParagraphId = await createWidget("101", "Insira um texto explicativo");

  const bottomSubtitleId = await createWidget("103", "Insira um subtítulo");
  const bottomParagraphId = await createWidget("101", "Insira um parágrafo final");

  const finalWidgetId = await createWidget("104", "table");

  layout = [
    // --- ROW 1 ---
    { x: 0, y: 0, w: 8, h: 2, i: titleId, resizeHandles: ["sw","nw","se"], static: false },
    { x: 9, y: 0, w: 4, h: 2, i: logoId, resizeHandles: ["sw","nw","se"], static: false },
    { x: 0, y: 2, w: 12, h: 1, i: paragraphId, resizeHandles: ["sw","nw","se"], static: false },

    // --- THEMES ---
    { x: 0, y: 4, w: 12, h: 1, i: subtitleThemesId, resizeHandles: ["sw","nw","se"], static: false },

    { x: 0, y: 5, w: 3, h: 2, i: themeParagraphIds[0], resizeHandles: ["sw","nw","se"], static: false },
    { x: 3, y: 5, w: 3, h: 2, i: themeParagraphIds[1], resizeHandles: ["sw","nw","se"], static: false },
    { x: 6, y: 5, w: 3, h: 2, i: themeParagraphIds[2], resizeHandles: ["sw","nw","se"], static: false },
    { x: 9, y: 5, w: 3, h: 2, i: themeParagraphIds[3], resizeHandles: ["sw","nw","se"], static: false },

    { x: 0, y: 7, w: 3, h: 1, i: dataTitleIds[0], resizeHandles: ["sw","nw","se"], static: false },
    { x: 3, y: 7, w: 3, h: 1, i: dataTitleIds[1], resizeHandles: ["sw","nw","se"], static: false },
    { x: 6, y: 7, w: 3, h: 1, i: dataTitleIds[2], resizeHandles: ["sw","nw","se"], static: false },
    { x: 9, y: 7, w: 3, h: 1, i: dataTitleIds[3], resizeHandles: ["sw","nw","se"], static: false },

    // --- FULL WIDTH WIDGET ---
    { x: 0, y: 8, w: 12, h: 4, i: fullWidgetTopId, resizeHandles: ["sw","nw","se"], static: false },

    // --- SPLIT ROW ---
    { x: 0, y: 13, w: 6, h: 4, i: leftWidgetId, resizeHandles: ["sw","nw","se"], static: false },
    { x: 6, y: 13, w: 6, h: 1, i: rightSubtitleId, resizeHandles: ["sw","nw","se"], static: false },
    { x: 6, y: 14, w: 6, h: 3, i: rightParagraphId, resizeHandles: ["sw","nw","se"], static: false },

    // --- BOTTOM CONTENT ---
    { x: 0, y: 18, w: 12, h: 1, i: bottomSubtitleId, resizeHandles: ["sw","nw","se"], static: false },
    { x: 0, y: 19, w: 12, h: 2, i: bottomParagraphId, resizeHandles: ["sw","nw","se"], static: false },

    { x: 0, y: 21, w: 12, h: 4, i: finalWidgetId, resizeHandles: ["sw","nw","se"], static: false }
  ];
}
break;

    }

    // Update layout
    if (layout.length > 0) {
      await axios.post(
        `${API_BASE_URL}/update-layout`,
        { DashboardId: dashboardId, layout },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      newDashboard.widgets = layout;
    }

    //temas
    await Promise.all(
  Object.entries(widgetThemesToApply).map(
    ([widgetId, theme]) =>
      saveWidgetThemeToDatabase(dashboardId, widgetId, theme)
  )
);


    await fetchData(
  `${API_BASE_URL}/dashboards/${projectId}`,
  setDashboards,
  setIsDashboardsLoaded,
  'dashboardData'
);

await fetchData(
  `${API_BASE_URL}/widgets/${projectId}`,
  setWidgets,
  setIsWidgetsLoaded,
  'widgetData'
);


    setModalMessage("Dashboard criado!");
    setModalMessageColor('#41BBC9');
    setModalIconId(1);
    setIsModalOpen(true);

  } catch (error) {
    console.error("Dashboard creation error:", error.response?.data || error.message);

    setModalMessage("Dashboard com erros...");
    setModalMessageColor('#E5004E');
    setModalIconId(2);
    setIsModalOpen(true);
  }
  finally {
    setIsCreating(false); // ✅ always stop loading
  }
};














  return (
  <div className="home-container" style={{ paddingLeft: '0px', paddingTop: '0px' }}>

  {/* 🔥 LOADING OVERLAY */}
    {isCreating && (
      <div className="loading-overlay">
        <MugIcon />
        <div className="loading-message">A criar o dashboard...</div>
        <div className="loading-spinner"></div>
      </div>
    )}

      <h2>Criar Dashboard</h2>
      <p>Configure o dashboard em poucos passos</p>

    <div className="create-project">
          <label className="project-name-label">Nome do Dashboard</label>
    <input
    type="text"
    placeholder="Inserir nome do dashboard"
    onChange={(e) => setnewWidgetName(e.target.value)}
    />

    <GraphicGroupSelector
  selectedGroup={selectedGroup}
  setSelectedGroup={setSelectedGroup}
  setGraphType={setGraphType}

  groups={dashboardTypeContainersData}
/>

  {graphType && (
  <button
    className="button"
    onClick={handleCreateWidget} // no need to pass parameters
    disabled={newWidgetName.trim() === ''} // disables if empty
    style={{
      marginTop: '20px',
      ...(newWidgetName.trim() === '' ? { opacity: 0.5, cursor: 'not-allowed' } : {})
    }}
  >
    Criar Dashboard
  </button>
)}

  </div>

{renderModal(isModalOpen, modalMessage, closeModal(setIsModalOpen), modalMessageColor, modalIconId)}
  </div>
);

}



export default ChartWidgetCreator;
